import { useLang } from '@inflearn/i18n-tools';
import type { LocaleOption } from 'echarts/types/src/core/locale';
import { get } from 'lodash-es';
import { useEffect } from 'react';

import { setDateLocal } from '../utils/date';
import { echarts } from '../utils/echarts';
import { langEN } from '../utils/echarts/langEN';
import { langJA } from '../utils/echarts/langJA';
import { langKO } from '../utils/echarts/langKO';
import { langVI } from '../utils/echarts/langVI';

export function useSetLocales() {
  const { lang } = useLang();

  useEffect(() => {
    // echarts locale 설정
    const ECHARTS_LANGUAGE_LOOKUP: Record<string, { locale: string; lang: LocaleOption }> = {
      ko: {
        locale: 'KO',
        lang: langKO,
      },
      en: {
        locale: 'EN',
        lang: langEN,
      },
      vi: {
        locale: 'VI',
        lang: langVI,
      },
      ja: {
        locale: 'JA',
        lang: langJA,
      },
    } as const;

    const currentEchartsLanguage = get(ECHARTS_LANGUAGE_LOOKUP, lang);

    if (!currentEchartsLanguage) {
      return;
    }

    echarts.registerLocale(currentEchartsLanguage.locale, currentEchartsLanguage.lang);
  }, [lang]);

  useEffect(() => {
    // dayjs locale 설정
    setDateLocal(lang);
  }, [lang]);
}
